"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BusinessObjectAssembler = void 0;
const tslib_1 = require("tslib");
const BusinessObjectAssemblerFactory_1 = require("./BusinessObjectAssemblerFactory");
const ModelClasses = tslib_1.__importStar(require("./model"));
const ModelCommon_1 = require("./model/ModelCommon");
const debug_1 = require("./util/lambda/debug");
const debug = debug_1.DEBUG_OVERRIDE || (debug_1.NOT_LAMBDA && false);
const nothing = {};
debug && console.log(`Unussed variable ${nothing} To make tsc emit .d.ts files with @iotv/iotv-v3-types references instead of ../iotvv3-types`);
const filtered = Object.entries(ModelClasses).filter(([k, c]) => {
    const descriptor = Object.getOwnPropertyDescriptor(ModelClasses, k);
    return descriptor?.get ? descriptor.get()?.prototype instanceof ModelCommon_1.ModelCommon : false;
});
const filteredModel = Object.fromEntries(filtered);
const BusinessObjectAssemblerL = (0, BusinessObjectAssemblerFactory_1.createBusinessObjectAssembler)(ModelClasses);
exports.BusinessObjectAssembler = BusinessObjectAssemblerL;
